import { memo } from 'react'
import styled from 'styled-components'
import { colorPalette } from '../../../../style/colorPalette'
import { SwimlaneCumulationData } from '../../Kanban'
import { roundNumber } from '../../../../../utils/number'
import { intl } from '../../../../../i18n'

type Props = {
  cumulation: SwimlaneCumulationData
  backgroundColor: string
}

export const SwimlaneStatusSummaryCard = memo(
  ({ cumulation, backgroundColor }: Props) => {
    const { count, estimatedHour, actualHour } = cumulation
    const isEmpty = count === 0
    const formattedEstimated = roundNumber(estimatedHour, 1)
    const formattedActual = roundNumber(actualHour, 1)

    return (
      <SummaryCard isEmpty={isEmpty} statusColor={backgroundColor}>
        <CountText isEmpty={isEmpty}>
          {intl.formatMessage(
            { id: 'kanban.column.header.hitShort' },
            { total: count }
          )}
        </CountText>
        <HourText isEmpty={isEmpty}>
          {intl.formatMessage(
            { id: 'kanban.column.header.estimatedHour' },
            { estimatedHour: formattedEstimated }
          )}{' '}
          /{' '}
          {intl.formatMessage(
            { id: 'kanban.column.header.actualHour' },
            { actualHour: formattedActual }
          )}
        </HourText>
      </SummaryCard>
    )
  }
)

const SummaryCard = styled('div')<{ isEmpty: boolean; statusColor: string }>(
  ({ isEmpty, statusColor }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '4px 8px',
    height: '24px',
    borderRadius: '4px',
    backgroundColor: statusColor,
    border: `1px solid ${colorPalette.monotone[2]}`,
    opacity: isEmpty ? 0.4 : 1,
    transition: 'opacity 0.15s ease',
    width: '100%',
  })
)

const CountText = styled('span')<{ isEmpty: boolean }>(({ isEmpty }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color: isEmpty ? colorPalette.monotone[4] : colorPalette.monotone[10],
  lineHeight: 1,
}))

const HourText = styled('span')<{ isEmpty: boolean }>(({ isEmpty }) => ({
  fontSize: '11px',
  fontWeight: 400,
  color: isEmpty ? colorPalette.monotone[4] : colorPalette.monotone[5],
  lineHeight: 1,
}))
